module.exports = __webpack_public_path__ + "img/icons8-infiniti.a7bc6248.svg";